import { render, staticRenderFns } from "./IndexDev.vue?vue&type=template&id=8f7d559e&scoped=true&"
import script from "./IndexDev.vue?vue&type=script&lang=js&"
export * from "./IndexDev.vue?vue&type=script&lang=js&"
import style0 from "./IndexDev.vue?vue&type=style&index=0&id=8f7d559e&scoped=true&lang=css&"
import style1 from "./IndexDev.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d559e",
  null
  
)

export default component.exports
import {QPageSticky,QTabPanels,QTabPanel,QBtnToggle,QTabs,QTab,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageSticky,QTabPanels,QTabPanel,QBtnToggle,QTabs,QTab,QTable})
